import React from 'react';
import { isNumber } from 'lodash';
import { Box, Button, Typography } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

import { resumeFileUrl } from '@constants';
import { ICandidateDetails } from '@types';
import { buttonSizeSx, secondaryButtonSx } from 'theme/buttons';
import { RankingValue } from 'components/common/RankingValue/RankingValue';
import { ScoreCell } from 'components/common/ScoreCell/ScoreCell';
import { Fact } from './DetailFacts';

export const AssessmentBlock: React.FC<{ data: ICandidateDetails }> = ({
  data,
}) => {
  const testTask = data.testTasks?.[0];

  return (
    <Box display="flex" flexWrap="wrap" gap={4}>
      <Fact label="Technical ranking">
        <RankingValue value={data.ranking?.technicalInterview ?? null} />
      </Fact>
      <Fact label="Soft skills">
        <RankingValue value={data.ranking?.softSkills ?? null} />
      </Fact>
      <Fact label="Test task">
        <ScoreCell
          testTask={
            testTask
              ? {
                  score: testTask.score,
                  status: testTask.status,
                  isPending: testTask.isPending,
                }
              : null
          }
          label="test task"
        />
      </Fact>
      {Boolean(data.profile?.englishLevel) && (
        <Fact label="English">
          <Typography variant="body1">{data.profile?.englishLevel}</Typography>
        </Fact>
      )}
      {isNumber(data.profile?.experience) && (
        <Fact label="Experience">
          <Typography variant="body1">
            {data.profile?.experience} years
          </Typography>
        </Fact>
      )}
      {Boolean(data.profile?.resumeName) && (
        <Fact label="Full resume">
          <Button
            component="a"
            href={resumeFileUrl(data.profile!.resumeName!)}
            target="_blank"
            rel="noopener"
            variant="outlined"
            startIcon={<DescriptionOutlinedIcon />}
            sx={{ ...buttonSizeSx.md, ...secondaryButtonSx }}
          >
            Open resume
          </Button>
        </Fact>
      )}
    </Box>
  );
};
